module.exports = __webpack_public_path__ + "img/020-flag.29ec6187.svg";